// src/pages/AdminModelsRouter.jsx
import React from "react";
import { useParams } from "react-router-dom";

import AdminGenericModelsPage from "./AdminGenericModelsPage.jsx";

const AdminModelsRouter = () => {
  const { featureCode } = useParams();

  // Kalau belum ada param, bisa tampilkan info simple
  if (!featureCode) {
    return (
      <div className="h-screen bg-slate-50 flex items-center justify-center">
        <p className="text-sm text-slate-500">
          Pilih salah satu fitur di menu <strong>Model AI</strong> pada sidebar.
        </p>
      </div>
    );
  }

  // Gunakan Generic Page untuk semua fitur
  return <AdminGenericModelsPage />;
};

export default AdminModelsRouter;
